import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { BarToneDirective } from '../../screen/bar-tone.directive';
import { ZoomableImageComponent } from '../zoomable-image/zoomable-image.component';
import { LightboxModal } from './lightbox.modal';

@NgModule({
  declarations: [LightboxModal],
  imports: [CommonModule, IonicModule, TranslateModule.forChild(), ZoomableImageComponent, BarToneDirective],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LightboxModule {}
